import React from 'react';

function MonthKey({ data, monthName, year }) {
  if (!data || data.length === 0) {
    return <div className="response">Details Not Found</div>;
  }
  const totalShops = data.reduce((sum, item) => sum + parseInt(item.totalShops || 0), 0);
  const totalCards = data.reduce((sum, item) => sum + (item.totalCards || 0), 0);
  const totalUnits = data.reduce((sum, item) => sum + (item.totalUnits || 0), 0);
  const totalAayCards = data.reduce((sum, item) => sum + parseInt(item.aayCards || 0), 0);
  const totalAayUnits = data.reduce((sum, item) => sum + parseInt(item.aayUnits || 0), 0);
  const totalPhhCards = data.reduce((sum, item) => sum + parseInt(item.phhCards || 0), 0);
  const totalPhhUnits = data.reduce((sum, item) => sum + parseInt(item.phhUnits || 0), 0);
  const totalBplCards = data.reduce((sum, item) => sum + parseInt(item.bplCards || 0), 0);
  const totalBplUnits = data.reduce((sum, item) => sum + parseInt(item.bplUnits || 0), 0);
  const totalNphCards = data.reduce((sum, item) => sum + parseInt(item.nphCards || 0), 0);
  const totalNphUnits = data.reduce((sum, item) => sum + parseInt(item.nphUnits || 0), 0);
  const totalExcCards = data.reduce((sum, item) => sum + parseInt(item.excCards || 0), 0);
  const totalExcUnits = data.reduce((sum, item) => sum + parseInt(item.excUnits || 0), 0);
  return (
    <div align="center">
      <table align="center" width="80%" border="1">
        <thead>
          <tr className="tableheader">
            <th colSpan="15">Key Register for <font style={{ color: "orange" }}>{monthName}</font> ' <font style={{ color: "orange" }}>{year}</font></th>
          </tr>
          <tr className="tableheader">
            <th rowSpan="3">Sl.No</th>
            <th rowSpan="3">District</th>
            <th rowSpan="3">Total<br/>Shops</th>
            <th rowSpan="3">Total<br/>Cards</th>
            <th rowSpan="3">Total<br/>Units</th>
            <th colSpan="6">NFSA</th>
            <th colSpan="4">Non-NFSA</th>
          </tr>
          <tr className="tableheader">
            <th colSpan="2">AAY</th>
            <th colSpan="2">PHH</th>
            <th colSpan="2">BPL</th>
            <th colSpan="2">NPH</th>
            <th colSpan="2">EXC</th>
          </tr>
          <tr className="tableheader">
            <th>Cards</th>
            <th>Units</th>
            <th>Cards</th>
            <th>Units</th>
            <th>Cards</th>
            <th>Units</th>
            <th>Cards</th>
            <th>Units</th>
            <th>Cards</th>
            <th>Units</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.distName}</td>
              <td align="right">{item.totalShops}</td>
              <td align="right">{item.totalCards}</td>
              <td align="right">{item.totalUnits}</td>
              <td align="right">{item.aayCards}</td>
              <td align="right">{item.aayUnits}</td>
              <td align="right">{item.phhCards}</td>
              <td align="right">{item.phhUnits}</td>
              <td align="right">{item.bplCards}</td>
              <td align="right">{item.bplUnits}</td>
              <td align="right">{item.nphCards}</td>
              <td align="right">{item.nphUnits}</td>
              <td align="right">{item.excCards}</td>
              <td align="right">{item.excUnits}</td>
            </tr>
          ))}
          <tr className="tableheader">
            <th>&nbsp;</th>
            <th>Total</th>
            <th align="right">{totalShops}</th>
            <th align="right">{totalCards}</th>
            <th align="right">{totalUnits}</th>
            <th align="right">{totalAayCards}</th>
            <th align="right">{totalAayUnits}</th>
            <th align="right">{totalPhhCards}</th>
            <th align="right">{totalPhhUnits}</th>
            <th align="right">{totalBplCards}</th>
            <th align="right">{totalBplUnits}</th>
            <th align="right">{totalNphCards}</th>
            <th align="right">{totalNphUnits}</th>
            <td align="right">{totalExcCards}</td>
            <td align="right">{totalExcUnits}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default MonthKey;
